const GigImages = ["/celine/posters/posternew.jpeg"];

export default GigImages;
